/* eslint eslint-comments/no-use: off */
/* eslint-disable @github-ui/github-monorepo/require-react-compiler-gates-import */
import {isFeatureEnabled} from '@github-ui/feature-flags'

/**
 * Exported methods in this file are used by the React Compiler's gating feature.
 *
 * Each method should be named in the form `isReactCompiler<FlagName>Enabled` and return a boolean.
 *
 * The React Compiler will call these methods to determine if a given feature flag (gate)
 * is enabled for a file, based on the annotation:
 *
 *   // @react-compiler gate=isReactCompilerDemoMyCustomGateEnabled
 *
 * This will cause the compiler to call `isReactCompilerDemoMyCustomGateEnabled()` at runtime.
 *
 * To add a new gate, export a new function following the naming convention and return
 * the result of your feature flag check.
 *
 * @example
 *   export const isReactCompilerMyCustomGateEnabled = () => {
 *     return isFeatureEnabled('react_compiler_my_custom_gate')
 *   }
 */

/**
 * Safely check if a feature flag is enabled. Returns false if the client environment
 * is not yet initialized (e.g., during SSR or test module initialization).
 */

function safeIsFeatureEnabled(flag: Parameters<typeof isFeatureEnabled>[0]): boolean {
  try {
    return isFeatureEnabled(flag)
  } catch {
    return false
  }
}

export const isReactCompilerCodeViewEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_code_view')
}

export const isReactCompilerDemoMyCustomGateEnabled = () => {
  return true // this is just an example, you might use something like safeIsFeatureEnabled('react_compiler_demo_my_custom_gate')
}
